<template>
	<div class="card-header">
        <div class="row">
        	<div class="col-12">	
	            <div class="animated slideInLeft" v-if="showTitle" style="animation-duration: 0.5s;">
	                <div>
		                <span style="font-size: 1.575rem;">
		                    {{title}}
		                </span> | {{total}}
		                <span class="float-right">
		                	<slot name="options"></slot>
		                	<button class="btn btn-link" v-on:click.prevent="showSearch()">
		                		<span class="badge badge-light" v-if="search" style="position: absolute; right: 10px; top: 3px;">1</span>
		                		<i class="material-icons">search</i>
		                	</button>
		                </span>
	                </div>
	                <div>
	                	<slot></slot>
	                </div>
	            </div>
	            <div class="animated slideInRight" v-else style="animation-duration: 0.3s;">
	            	<div>
		            	<form id="search-form" autocomplete="off">
		            		<div class="search-container">
		            			<div class="search-icon">
		            				<button class="btn btn-link border-0" ref="searchBTN" title="Buscar">
		                                <i class="material-icons text-black">search</i>
		                            </button>
		            			</div>
		            			<div class="seach-input">
		            				<div class="d-flex">
		            					<input type="text" ref="search" v-bind:class="{'form-control border-0':true, 'input-with-clear':showClose}" v-model="search" id="search" placeholder="Buscar..." autofocus="true">
		            					<input type="text" name="search" v-model="searchAux" class="d-none">
			            				<a href="#" class="btn btn-link input-clear" v-if="showClose" v-on:click.prevent="clearSearch()" title="Borrar búsqueda">
			            					<i class="material-icons text-black">close</i>
			            				</a>
		            				</div>
		            			</div>
		            			<div class="search-icon">
		            				<button type="button" class="btn btn-link border-0" v-on:click.prevent="returnTitle()" v-tooltip="'Regresar'">
		                                <i class="material-icons text-black">arrow_back</i>
		                            </button>
		            			</div>
		            		</div>
		                </form>
	            	</div>
	            </div>
        	</div>
        </div>
    </div>
</template>
<script>
	export default{
		props: ['title', 'total'],

		mounted(){
			this.search = this.findGetParameter('search');
			if (this.search) {
				this.showTitle = false;
			}
		},

		data(){
			return {
				showTitle: true,
				search: '',
				showClose: false,
			}
		},

		watch: {
		    search: function (value) {
				if(value){
					this.showClose = true;
				}else{
					this.showClose = false;
				}
			}
		},

		methods: {
			showSearch() {
				this.showTitle = false;
				this.$nextTick(() => {
					this.$refs.search.focus();
				});
			},

			clearSearch(){
				this.search = '';
				this.showClose = false;

				if(this.findGetParameter("search")){
					this.$nextTick(() => {
						this.$refs.searchBTN.click();
					});
				}
			},

			returnTitle() {
				this.showTitle = true;
			},

			update(){
				window.location = window.location.href.split("?")[0];
			},

			findGetParameter: function(parameterName) {
		    	var result = null,
		        tmp = [];
		    	location.search
		        	.substr(1)
		        	.split("&")
		        	.forEach(function (item) {
		        tmp = item.split("=");
		        	if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		        	
		        	});
		    	if(result != null){
		    		return decodeURIComponent(result);
		    	}else{
		    		result
		    	}
			},
		},
		computed: {
		    searchAux: function () {
		    	if(this.search != null){
		    		return encodeURIComponent(this.search);
		    	}else{
		    		this.search
		    	}
		    }
		}
	}
</script>
<style scoped>
	.form-control:focus{
		box-shadow: none;
	}

	.search-container {
		display: flex;
	}

	.search-icon {
		width: 50px;
	}

	.seach-input {
		width: calc(100% - 100px);
	}

	.input-with-clear {
		width: calc(100% - 40px);
	}

	.input-clear{
		width: 40px;
	}
</style>